import { Component } from '@angular/core'

@Component({
  selector: 'app-price-evolution',
  templateUrl: './price-evolution.component.html',
  styleUrls: ['./price-evolution.component.scss']
})
export class PriceEvolutionComponent {}
